import { create } from 'zustand';

interface AddEncounterOnMapModalState {
  isOpen: boolean;
  objectSlug: string;
  planSlug: string;
  onManageAddEncounterOnMapClose: () => void;
  onManageAddEncounterOnMapOpen: (objectSlug: string, planSlug?: string) => void;
}

export const useAddEncounterOnMapModalStore = create<AddEncounterOnMapModalState>(set => ({
  isOpen: false,
  objectSlug: '',
  planSlug: '',
  onManageAddEncounterOnMapClose: () => set({ isOpen: false, objectSlug: '', planSlug: '' }),
  onManageAddEncounterOnMapOpen: (objectSlug: string, planSlug?: string) =>
    set({ isOpen: true, objectSlug: objectSlug || '', planSlug: planSlug || '' }),
}));
